export default "__VITE_ASSET__DcLxIt6w__"